import axios from 'axios';

import { TimeFilter } from '@tallo/utility';

import { PropertyStatisticsDto } from '../dtos/property-statistics.dto.interface';

class PropertyStatisticsService {
  async getPropertyStatistics(propertyId: string, filter: TimeFilter): Promise<PropertyStatisticsDto> {
    const response = await axios.get(`property-statistics/${propertyId}`, {
      params: {
        filter,
      },
    });

    return response.data;
  }

  async downloadPropertyStatistics(propertyId: string, filter: TimeFilter): Promise<Blob> {
    const response = await axios.get(`property-statistics/${propertyId}/download`, {
      params: {
        filter,
      },
      responseType: 'blob',
    });

    return response.data;
  }

  /** The leads of every unit the seat works, or only of one portfolio's (`unassigned` for the units in none) */
  async downloadCompanyStatistics(companyId: string, filter: TimeFilter, portfolio?: string): Promise<Blob> {
    const response = await axios.get(`property-statistics/company/${companyId}/download`, {
      params: { filter, portfolio },
      responseType: 'blob',
    });

    return response.data;
  }
}

export default new PropertyStatisticsService();
